import type { PictureView } from '../../common/pictureView/pictureView';

export enum ExtranetRoomStatus {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
  DELETED = 'DELETED',
}

/**
 * Extranet Hotel Room Types
 */
export type Bed = {
  id: number;
  roomId: number;
  price?: number;
  included: boolean;
  categoryId: number;
};

export type ExtranetHotelRoom = {
  id: number;
  name?: string;
  hotelId: number;
  categoryId: number;
  categoryName: string;
  hotelPriority?: number;
  status: ExtranetRoomStatus;
  categoryRoomCount?: number;
  bookingcomId?: number;
  bookingcomName?: string;
  coverPicture?: PictureView;
  beds: Bed[];
};
